interface CheckboxInputProps {
  checked: boolean;
  setChecked: (checked: boolean, id: string) => void;
  id: string;
  isDisabled?: boolean;
}
const CheckboxInput = ({
  checked,
  setChecked,
  id,
  isDisabled = false
}: CheckboxInputProps): JSX.Element => {
  const handleChange = () => {
    setChecked(!checked, id);
  };
  return <input id={id} type='checkbox' checked={checked} onChange={handleChange} disabled={isDisabled} className='h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded' data-sentry-component="CheckboxInput" data-sentry-source-file="Checkbox.tsx" />;
};
export default CheckboxInput;